import React, {useEffect, useState} from "react";
import Link from "next/link";
import Image from "next/image";
import {getTransactions} from '../../utils/api';
import moment from "moment";
import {FaCoins, FaLock, FaArrowAltCircleRight, FaEye} from "react-icons/fa";
import {TbTransfer} from "react-icons/tb";
import {getAccountHolderId, getUserId} from "../../utils/jwtUtil";
import {useRouter} from "next/router";

const Activity_item = () => {

    const router = useRouter();
    const [filterVal, setFilterVal] = useState(null);
    const [accountHolderId, setAccountHolderId] = useState(null);
    const [projects, setProjects] = useState(null);
    const {data, error} = getTransactions(accountHolderId);
    const [transactions, setTransactions] = useState(data);

    useEffect(() => {
        setAccountHolderId(getAccountHolderId());
    }, []);

    useEffect(() => {
        if (data && Array.isArray(data)) {
            const projectId = router.query.collection;
            let transactionsToUse;
            if (projectId) {
                transactionsToUse = data.filter(transaction => transaction.projectId === projectId);
            } else {
                transactionsToUse = data;
            }
            setTransactions(transactionsToUse);

            const uniqueProjectNames = Array.from(new Set(transactionsToUse.map(item => item.projectName)))
                .map(projectName => ({projectName}));

            setProjects(uniqueProjectNames);

        }
    }, [data]);

    const handleFilter = (projectName) => {
        if (data && Array.isArray(data)) {
            const transactionsForProject = data.filter((item) => item.projectName === projectName);
            setTransactions(transactionsForProject);
        }
    };

    return (
        <>
            {/* <!-- Activity Tab --> */}
            <div className="tab-pane fade">
                {/* <!-- Records / Filter --> */}
                <div className="lg:flex">
                    {/* <!-- Records --> */}

                    {/* <!-- Table --> */}
                    <div className="scrollbar-custom overflow-x-auto">
                        <div
                            role="table"
                            className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 lg:rounded-2lg w-full min-w-[736px] border bg-white text-sm dark:text-white"
                        >
                            <div
                                className="dark:bg-jacarta-600 bg-jacarta-50 rounded-t-2lg flex"
                                role="row"
                            >
                                <div className="w-[28%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Project
                  </span>
                                </div>
                                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Type
                  </span>
                                </div>
                                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    From
                  </span>
                                </div>
                                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    To
                  </span>
                                </div>
                                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Qty
                  </span>
                                </div>
                                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    When
                  </span>
                                </div>
                                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Price
                  </span>
                                </div>
                                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Value
                  </span>
                                </div>
                                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Public Record
                  </span>
                                </div>
                            </div>
                            {Array.isArray(transactions) && transactions.length > 0 ? (
                                transactions.map((item, index) => {
                                    const {
                                        fromAddress,
                                        fromName,
                                        toAddress,
                                        toName,
                                        blockNum,
                                        hash,
                                        tokenId,
                                        amount,
                                        projectId,
                                        projectName,
                                        type,
                                        txDate,
                                        source,
                                        transactionId
                                    } = item;
                                    const userLocale = navigator.language || 'en-AU';
                                    const amountAsString = new Intl.NumberFormat(userLocale).format(amount);
                                    const icon = type === "Mint" ? <FaCoins/> : type === "Burn" ? <FaLock/> :
                                        <TbTransfer/>;
                                    const typeString = (type === "Burn") ? "Pledge" : type;
                                    const fromNameString = (!fromName) ? "Account" : fromName;
                                    const toNameString = (!toName) ? "Account" : toName;
                                    const whenString = moment(txDate).fromNow();

                                    return (
                                        <div key={Math.floor((Math.random() * 1000000) + 1)}
                                             className="flex transition-shadow hover:shadow-lg"
                                        >
                                            <div
                                                className="dark:border-jacarta-600 border-jacarta-100 flex w-[28%] items-center border-t py-4 px-4"
                                                role="cell">
                                                <figure
                                                    className="relative mr-2 w-8 shrink-0 self-start lg:mr-5 lg:w-12">
                                                    <Image
                                                        src={`/images/projects/${projectId}.webp`}
                                                        alt={projectName}
                                                        height={32}
                                                        width={32}
                                                        className="rounded-2lg object-contain"
                                                    />
                                                </figure>
                                                <span
                                                    className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
                                                  {projectName}
                                                </span>
                                            </div>
                                            <div
                                                className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center whitespace-nowrap border-t py-4 px-4"
                                                role="cell">
                                              <span className="text-sm font-medium tracking-tight">
                                                {icon}
                                              </span>
                                                <span
                                                    className="ml-2"> {/* Use a span element for the type with margin-left */}
                                                    {typeString}
                                              </span>
                                            </div>
                                            <div
                                                className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                                                role="cell">
                                                <span> {fromNameString}</span>
                                            </div>
                                            <div
                                                className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                                                role="cell">
                                                <span> {toNameString}</span>
                                            </div>
                                            <div
                                                className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                                                role="cell">
                                              <span className="text-sm font-medium tracking-tight">
                                                {amountAsString}
                                              </span>
                                            </div>
                                            <div
                                                className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                                                role="cell">
                                              <span className="text-sm font-medium tracking-tight" title={txDate}>
                                                {whenString}
                                              </span>
                                            </div>
                                            <div
                                                className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                                                role="cell">
                                                <span> - </span>
                                            </div>
                                            <div
                                                className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                                                role="cell">
                                                <span> - </span>
                                            </div>
                                            <div
                                                className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                                                role="cell">
                                                {source === "Polygon" && (
                                                    <Link
                                                        href={`https://amoy.polygonscan.com/tx/${hash}`}
                                                        key={`${blockNum}_${index}`}
                                                        target="_blank"
                                                        className="flex transition-shadow hover:shadow-lg"
                                                    >
                                                        <FaEye/>
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="text-center text-lg text-jacarta-500 dark:text-jacarta-200">
                                    -
                                </div>
                            )}
                        </div>
                    </div>
                    {Array.isArray(projects) && projects.length > 0 && (
                        <aside className="basis-4/12 lg:pl-5">
                        <h3 className="font-display text-jacarta-500 mb-4 font-semibold dark:text-white">
                                Filters
                            </h3>
                            <div className="filter flex flex-wrap">
                                {projects?.map((item, index) => {
                                    const {projectName} = item;
                                    return (
                                        <button
                                            className={
                                                filterVal === projectName
                                                    ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border px-4 py-3 border-transparent text-white dark:border-transparent"
                                                    : "dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border bg-white px-4 py-3 hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent"
                                            }
                                            key={`${projectName}_${index}`}
                                            onClick={() => {
                                                handleFilter(projectName);
                                                setFilterVal(projectName);
                                            }}
                                        >
                      
                      <span className="text-2xs font-medium capitalize">
                        {projectName}
                      </span>
                                        </button>
                                    );
                                })}
                            </div>
                        </aside>
                    )}
                </div>
            </div>
        </>
    );
};

export default Activity_item;